import { Language } from '@repo/ui/lang'

import { OrganizationCreatorDialog } from '@/components/onboarding/OrganizationCreator'
import { sudoStoreActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'

export function OrganizationCreator() {
  const dispatch = useStoreDispatch()
  return (
    <OrganizationCreatorDialog
      defaultLanguage={Language.EN}
      onSubmit={(v) => void dispatch(sudoStoreActions.organization.create(v))}
      className="w-fit"
    />
  )
}
